// extracted by mini-css-extract-plugin
export var image = "bw_bS";